import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { Bold } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { useInitializePaypalButton } from './hooks/useInitializePaypalButton';
import { messages } from './messages';
import { StyledButtonContainer, StyledPayPalExpressCheckoutWrapper } from './styled';

export const CartPayPalExpressCheckout: ReactFCV = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { isPayPalReady, paypalForm } = useInitializePaypalButton(containerRef);

  if (!isPayPalReady) {
    return null;
  }

  return (
    <StyledPayPalExpressCheckoutWrapper>
      <StyledButtonContainer ref={containerRef} />
      <Bold>
        <FormattedMessage {...messages.payWithPayPalOrProceedToCheckout} />
      </Bold>
      {paypalForm}
    </StyledPayPalExpressCheckoutWrapper>
  );
};
